(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 6325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(41925);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Onboarding__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23244);
/* harmony import */ var _components_SplashScreen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70613);




var __N_SSP = true;
function Home(props) {
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsLoading(false);
    }, []);
    if (isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SplashScreen__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            wl: props.wl
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Onboarding__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            bgImg: ((ref = props.wl) === null || ref === void 0 ? void 0 : ref.usar_configuracao_padrao) ? "/images/onboarding/onboarding-back-01.svg" : "",
            mascotImg: props.mascotImg,
            titlePage: props.title,
            descPage: props.description,
            skipPage: true,
            onboarding: 1,
            nextUri: "/onboarding/onboarding-2",
            wl: props.wl
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5381,3244,9774,2888,179], function() { return __webpack_exec__(6325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);